<!--
 * @Description: 搜索框及选择日期会场部分
 * @Author: 山淑兰
 * @Date: 2019-11-26 14:39:07
 * @LastEditTime: 2020-06-23 12:52:43
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="search">
		<div class="schedule-con">
			<div class="language" v-if="languageShow">
				<span @click="changeLocale('zh-CN')">中文</span>
				|
				<span @click="changeLocale('en-US')">EN</span>
			</div>		
			<div class="search">
				<input type="text" :placeholder="$t('meeting.header.search.placeholder')" class="search-inp"
					v-model="searchKeyword" />
				<div class="search-btn" @click="search()">
					<van-icon name="search" />
				</div>
			</div>
			<div class="selection">
				<template>
					<div class="select">
						<div class="dataTime">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item,index) in datas.timeList" :key="item.value"
									:class="{ blue:index==current}" :id="'nav' + index" v-trigger="index==current"
									@click="chooseItem_clickHandler(index,item,'times',$event,true)">
									{{ item.name }}
								</div>
							</div>
						</div>
						<div class="timeData addressData">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item,index) in datas.addressList" :key="item.value"
									:class="{ blue:index==current1}"
									@click="chooseItem_clickHandler(index,item,'address',$event)">
									{{ item.name }}
								</div>
							</div>
							<!-- <li
                v-for="(item,index) in datas.addressList"
                :key="item.value"
                :class="{ blue1:index==current1}"
                @click="chooseItem_clickHandler(index,item,'address',$event)"
              >
                {{ item.name }}
              </li> -->
						</div>
					</div>
				</template>
			</div>
			<div class="pinyin">(*{{$t('meeting.header.search.sort')}})</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'searchnew',
		props: ['pupopData','languageShow'],
		data() {
			return {
				m: '',
				roomid: '',
				rid: '',
				language: 0,  //0中文，1英文
				searchKeyword: '', // 搜索框的值
				// 选择按钮初始值
				labels: {
					times: '',
					address: '',
				},
				//  分辨两个按钮
				flags: {
					type: 'address',
					isShow: false,
				},
				datas: {
					// 弹出框两种数据
					timeList: [],
					addressList: [],
				},
				dateid: '',
				current: -1,
				current1: -1,
			}
		},
		watch: {
			pupopData: {
				handler() {
					this.datas.timeList = this.pupopData
					console.log(this.pupopData)
					if (this.dateid != undefined) {
						for (let i in this.datas.timeList) {
							if (this.datas.timeList[i].value == this.dateid) {
								this.current = i
								this.chooseItem_clickHandler(this.current, this.datas.timeList[i], 'times', '', false)
							}
						}
					} else {
						this.current = 0
					}

					this.swiperInit()
				},
			},
		},
		directives: {
			trigger: {
				inserted(el, binging, index) {
					//el.click()
				}
			}
		},
		created() {
			let {
				m,
				roomid,
				dateid,
				rid,
				language
			} = this.$route.query
			this.dateid = dateid
			this.m = m
			this.rid = rid
			this.language = language
			if (roomid) {
				this.roomid = roomid
			} else {
				this.current1 = -1
			}
			console.log(this.language)
			if( !this.languageShow ){
				this.$i18n.locale = 'zh-CN'
			}else{
				if( this.language == 0 ){
					this.$i18n.locale = 'zh-CN'
				}else if( this.language == 1 ){
					this.$i18n.locale = 'en-US'
				}
			}
		},
		mounted() {
			this.swiperInit()
		},
		methods: {
			swiperInit() {
				this.$nextTick(function() {
					var navSwiper = new Swiper('.dataTime', {
						observer: true,
						observeParents: true,
						freeMode: true,
						slidesPerView: 'auto',
						freeModeSticky: true,
					})
				})
				this.$nextTick(function() {
					var navSwiper = new Swiper('.addressData', {
						observer: true,
						observeParents: true,
						freeMode: true,
						slidesPerView: 'auto',
						freeModeSticky: true,
					})
				})
			},
			//中英文切换
			changeLocale(type) {
				this.$i18n.locale = type
			},
			//点击弹出右侧弹出层
			chooseTab_clickHandler(type) {
				this.flags.type = type //  按钮的值传给中间件
				if (type === 'address') {
					if (this.datas.addressList.length > 0) {
						this.flags.isShow = true
					}
				} else {
					this.flags.isShow = true
				}
			},
			//  点击右侧弹出层中的列表
			chooseItem_clickHandler(index, data, flag, event, jump) {
				const {
					type
				} = flag
				this.flags.isShow = false
				if (flag === 'times') {
					this.current1 = 0;
					this.current = index;
					this.datas.addressList = data.child
					this.datas.addressList.shift()
					// 将dateid 传入到roomList中
					const dateid = data.value
					this.dateid = data.value
					this.labels.address = '' //选择日期后，将会场按钮字段改为‘选择会场’
					let {
						roomid
					} = this.$route.query
					this.roomid = roomid
					console.log(this.roomid)
					if (this.roomid) {
						for (let i in this.datas.addressList) {
							if (this.datas.addressList[i].value == this.roomid) {
								this.current1 = i
							}
						}
					} else {
						if (this.current == 0) {
							// this.toLinkList('/mproguest/place', {
							// 	dateid: this.dateid
							// })
						} else {
							const roomId = this.datas.addressList[0].value
							console.log(roomId)
							this.toLinkList('/mproguest/scheduleList', {
								roomid: roomId,
								dateid: this.dateid,
								language: this.language
							})
						}
					}
					if (jump) {
						this.toLinkList('/mproguest/place', {
							dateid,
						})
					}
				} else {
					this.current1 = index;
					const roomid = data.value
					console.log(roomid)
					if (roomid == 0) {
						this.toLinkList('/mproguest/place', {
							dateid: this.dateid
						})
					} else {
						this.toLinkList('/mproguest/scheduleList', {
							roomid,
							dateid: this.dateid
						})
					}
				}
				this.labels[type] = data.name //  点击日期或会场列表后，改变按钮的值
			},

			/**
			 * @description 跳转页面
			 */
			toLinkList(path, params) {
				const m = this.m
				const rid = this.rid
				this.$router.push({
					path: path,
					query: {
						m,
						rid,
						...params
					},
				})
			},
			/**
			 * @description 搜索
			 */
			search() {
				const m = this.m
				const rid = this.rid
				const roomid = this.roomid
				if (this.searchKeyword !== '') {
					let search = this.searchKeyword
					this.$router.push({
						path: '/mproguest/searchList',
						query: {
							m,
							rid,
							roomid,
							search
						},
					})
				} else {
					this.$router.push({
						path: '/mproguest/place',
						query: {
							m,
							roomid,
							rid
						},
					})
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
	* {
		-webkit-box-sizing: border-box;
		box-sizing: border-box
	}

	.schedule-con {
		overflow-x: hidden;
		.language {
			font-size: 28px;
			text-align: right;
			color: #fff;
			margin-bottom: 10px;
		}
		.pinyin{
			text-align: right;
			color: #333;
			font-size: 28px;
			font-weight: bold;
			padding: 15px 20px 10px 0;
		}
		.search {
			margin: 10px auto 0;
			width: 95%;
			box-sizing: border-box;
			display: flex;
			border-radius: 40px;
			overflow: hidden;
			border: 1px solid #ddd;
			.search-inp {
				border-radius: 0;
				flex: 1;
				height: 74px;
				font-size: 28px;
				padding: 0 20px;
				color: #333;
			}

			.search-inp::-webkit-input-placeholder {
				color: #666;
			}

			.search-inp:-moz-placeholder {
				color: #666;
			}

			.search-inp::-moz-placeholder {
				color: #666;
			}

			.search-inp:-ms-input-placeholder {
				color: #666;
			}

			.search-btn {
				width: 78px;
				height: 74px;
				text-align: center;
				background: rgba(22, 68, 154, 1);
				.van-icon {
					color: #fff;
					font-size: 40px;
					padding-top: 16px;
				}
			}

			
		}

		.selection {
			width: 100%;
			padding: 20px 0 25px;
			display: flex;

			.select {
				width: 100%;
				font-size: 28px;

				.dataTime {
					width: 100%;
					padding-bottom: 10px;

					.swiper-slide {
						padding: 0 20px;
						width: auto;
						color: #333;
					}

					.blue {
						position: relative;
						color: rgba(22, 68, 154, 1);
					}

					.blue:after {
						position: absolute;
						display: block;
						content: '';
						height: 5px;
						left: 30px;
						right: 30px;
						bottom: -8px;
						background: rgba(22, 68, 154, 1);
					}
				}

				.addressData {
					width: 100%;
					padding-bottom: 10px;

					.swiper-slide {
						padding: 0 20px;
						width: auto;
						color: #333;
					}

					.blue {
						position: relative;
						color: rgba(22, 68, 154, 1);
					}

					.blue:after {
						position: absolute;
						display: block;
						content: '';
						height: 5px;
						left: 30px;
						right: 30px;
						bottom: -8px;
						background: rgba(22, 68, 154, 1);
					}
				}

				.timeData {
					width: 100%;
					text-align: center;
					display: flex;
					flex-wrap: wrap;
					padding: 0 20px;
					margin-top: 20px;

					li {
						width: 25%;
						text-align: center;
						margin-bottom: 15px;
					}
				}

				.addressData {
					li {
						width: 33.3%;
						padding: 5px 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						color: #fff;
					}

					.blue1 {
						background: #00439a;
					}
				}
			}

			.select-date,
			.select-space {
				flex: 1;
				text-align: center;
				line-height: 88px;
				font-size: 28px;
				border-bottom: 1px solid #d4d9dd;
				border-top: 1px solid #d4d9dd;
				position: relative;

				.arrow {
					position: absolute;
					right: -1px;
					bottom: -6px;
					display: inline-block;
					width: 0;
					height: 0;
					border-top: 10px solid transparent;
					border-bottom: 10px solid transparent;
					border-left: 10px solid #00439a;
					vertical-align: middle;

					transform: rotate(45deg);
				}
			}

			.select-date {
				border-right: 1px solid #ccc;
			}

			.list-popup {
				width: 48%;
				height: 100%;
				background: #333;
				font-size: 28px;

				ul {
					li {
						color: #fff;
						border-bottom: 1px solid #111;
						padding: 20px 10px;
					}
				}
			}
		}
	}
</style>
